import { REVEAL_BASE_DELAY_MS, REVEAL_STAGGER_MS } from './constants';

/** `animationDelay` for the `index`-th item of a staggered `aiPillRevealClass` list. */
export const getRevealDelay = (index) => `${REVEAL_BASE_DELAY_MS + index * REVEAL_STAGGER_MS}ms`;
